import { createFileRoute, redirect } from '@tanstack/react-router';
import { toast } from 'sonner';

import BookingPage from '@/pages/booking/BookingPage';

export const Route = createFileRoute('/booking/')({
  component: () => <BookingPage />,

  beforeLoad: async ({ context, location }) => {
    if (!context.isLoggedIn) {
      sessionStorage.setItem('redirectAfterLogin', location.href);
      toast('알림', {
        description: '로그인이 필요한 서비스입니다.',
      });
      throw redirect({ to: '/sign-in' });
    }
  },
});
